//@flow
import * as React from 'react';
import {connect} from "react-redux";
import SearchInput
  from "../../../../../components/composed/SearchPage/SearchBox/ConnectedSearchInput/SearchInput/SearchInput";
import text from "../../../../../services/localization/text";
import type {inputIsFocused, spinnerIsShown} from "../../../../../services/flowTypes/appFlowTypes";
import type {
  organizationName
} from "../../../../../services/flowTypes/dataFlowTypes";
import {handleSearchIcoClick, onUpdateMyOrganizationsSearchProp} from "../../../../../services/flowTypes/propFnFlowTypes";
import myOrganizationsSearchActions
  from "../../../../../store/myOrganizations/myOrganizationsSearch/myOrganizationsSearchActions";

type Props = {
  name: organizationName,
  onUpdateMyOrganizationsSearchProp: onUpdateMyOrganizationsSearchProp,
  handleSearchIcoClick: handleSearchIcoClick,
  spinnerIsShown: spinnerIsShown
};
type State = {
  inputIsFocused: inputIsFocused
};
class ConnectedMyOrganizationsSearchInput extends React.Component <Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = {
      inputIsFocused: true
    };
  }
  onBlur = () => {this.setState({inputIsFocused: false})};
  onFocus = () => {this.setState({inputIsFocused: true})};
  onChange = (e:SyntheticEvent<HTMLInputElement>) => {
    const myOrganizationsSearchObj = {
      offset: 0,
      name: e.target.value
    };
    this.props.onUpdateMyOrganizationsSearchProp(myOrganizationsSearchObj);
  };
  render() {
    return (
      <SearchInput
        spinnerIsShown={this.props.spinnerIsShown}
        inputIsFocused={this.state.inputIsFocused}
        handleSearchIcoClick={this.props.handleSearchIcoClick}
        onFocus={this.onFocus}
        onBlur={this.onBlur}
        onChange={this.onChange}
        text={this.props.name}
        placeholder={text.organizationsSearchPlaceholder}
      />
    );
  }
}

const mapStateToProps = state => {
  return {
    name: state.myOrganizations.search.name
  };
};

const mapDispatchToProps = dispatch => {
  return {
    onUpdateMyOrganizationsSearchProp: (myOrganizationsSearchObj) => dispatch({
      type: myOrganizationsSearchActions.MY_ORGANIZATIONS_SEARCH_PROP_UPDATE,
      value: myOrganizationsSearchObj})
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(ConnectedMyOrganizationsSearchInput);